import { EdgeMode, IConnector, Vector2 } from "../datastructures/dataviz";
import { ConnectorType } from "../datastructures/coursedata";
import "../styles/edges.css";

export function Connector(connectorData: IConnector) {
  // const A = connectorData.sourceNodeRef.position
  // const B = connectorData.destNodeRef.position

  return (
    <>
      {connectorData.styleMode !== EdgeMode.HIDDEN ? (
        <>
          <marker
            id="arrowhead_strong"
            markerWidth="5"
            markerHeight="5"
            refX="0"
            refY="2.5"
            orient="auto"
          >
            <polygon
              opacity={0.5}
              points="0 0, 5 2.5, 0 5, 1 2.5"
              className="arrowhead_strong"
            />
          </marker>
          <marker
            id="arrowhead_dim"
            markerWidth="5"
            markerHeight="5"
            refX="0"
            refY="2.5"
            orient="auto"
          >
            <polygon
              opacity={0.2}
              points="0 0, 5 2.5, 0 5, 1 2.5"
              className="arrowhead_dim"
            />
          </marker>
          <line
            x1={connectorData.sourceNodeRef.position.x}
            y1={connectorData.sourceNodeRef.position.y}
            // x2 ={connectorData.destNodeRef.position.x}
            // y2 ={connectorData.destNodeRef.position.y}
            x2={
              GetEndPointWithRadius(
                connectorData.sourceNodeRef.position,
                connectorData.destNodeRef.position,
                25
              ).x
            }
            y2={
              GetEndPointWithRadius(
                connectorData.sourceNodeRef.position,
                connectorData.destNodeRef.position,
                25
              ).y
            }
            className={`dashed-outline-flow edge_base connector_edge_${
              connectorData.connType === ConnectorType.RELATION
                ? "relation"
                : "normal"
            } edgemode_${connectorData.styleMode}`}
            markerEnd={`url(${
              connectorData.styleMode === EdgeMode.HIGHLIGHT ||
              connectorData.styleMode === EdgeMode.SEMI_HIGHLIGHT
                ? "#arrowhead_strong"
                : "#arrowhead_dim"
            })`}
          >
            {/* <title>
            {""}
          </title> */}
          </line>
        </>
      ) : null}
    </>
  );
}

const GetEndPointWithRadius = (
  p1: Vector2,
  p2: Vector2,
  r: number
): Vector2 => {
  let vec = { x: p2.x - p1.x, y: p2.y - p1.y };
  let mag = Math.sqrt(vec.x * vec.x + vec.y * vec.y);
  let vnorm = { x: vec.x / mag, y: vec.y / mag };
  let endpt = { x: p2.x - 2.6 * r * vnorm.x, y: p2.y - 2.6 * r * vnorm.y };
  return endpt;
};
